import React from 'react';
import { ExternalProvider } from '../../../../../lib';
import CareMapprButton from '../../../../components/Button/CareMapprButton';
import { useExternalAuth } from '../../context/ExternalAuthProvider';
import BaseOAuthModal from './BaseOAuthModal';

interface WithingOAuthModalProps {
  provider: ExternalProvider;
}

const WithingOAuthModal = ({ provider }: WithingOAuthModalProps) => {
  const { onClose } = useExternalAuth();

  return (
    <BaseOAuthModal provider={provider} header={<h3>Connect to {provider}</h3>}>
      <div className="d-flex flex-column gap-3">
        <p>
          You're redirecting to Withings to authorize CareMappr. Please follow
          the instructions to complete the connection.
        </p>
        <CareMapprButton
          onClick={() => {
            onClose();
          }}
        >
          Close
        </CareMapprButton>
      </div>
    </BaseOAuthModal>
  );
};

export default WithingOAuthModal;
